module.exports = __webpack_public_path__ + "img/scifi.1aef7975.png";